<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template> 
<script setup >

const { locale } = useI18n();
const siteStore  = useSiteStore();
const localHead  = useLocaleHead({ addDirAttribute: true, addSeoAttributes: true }) 

// Root --bs-primary follows the site's header colour so every var(--bs-primary) accent
// (section heading underlines, dividers) matches it; resolveTheme only yields validated hex.
const rootThemeStyle = () => `--bs-primary: ${siteStore.primaryColor}`;

useHead({ htmlAttrs: { lang: locale, dir: () => localHead.value.htmlAttrs.dir, style: rootThemeStyle } })

</script>
<script>
export default { name      : 'BL2App', };
</script>
<style lang="css">
/* Allowed embedded frames (app/utils/html.js applyEmbedEntry). Height or ratio comes inline. */
.iframe-responsive {
  display: block;
  width: 100%;
  max-width: 100%;
  border: 0;
}
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
/* main{
  margin-bottom: 700px;
} */
.pointer{
    cursor: pointer;
}
.dark {
    --popper-theme-background-color: #333333;
    --popper-theme-background-color-hover: #333333;
    --popper-theme-text-color: white;
    --popper-theme-border-width: 0px;
    --popper-theme-border-radius: 6px;
    --popper-theme-padding: 32px;
    --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
.popper{
    max-width: 50% !important;
}

.not-allowed {
        pointer-events: auto! important;
        cursor: not-allowed! important;
    }
.debug{
  border: 1px dashed red;
}
.debug-blue{
  border: 2px dashed blue;
  z-index: 100;
}
.debug-main{
  border: 1px dashed red;
  min-height: 500px;
}
.debug2{
  border: 2px dashed red;
}
.debug3{
  border: 3px dashed red;
}
.db{
        border: 2px dashed rgb(157, 2, 2);
        width:100%;
        text-align: center;
    }
</style>
<style lang="scss">
@import "@/assets/scss/variables.scss";

.arrow{
    width        : 1.3e m            ;
    height       : 1.3e m            ;
    cursor       :      pointer      ;
    margin-bottom: 0.2  rem          ;
}

// Typography
@media (max-width: 1375.98px) {
  html {
      font-size: 15px;
  }
}

@media (max-width: 1247.98px) {
  html {
      font-size: 14px;
  }

  .display-1 {
      font-size: 5rem;
  }

  .display-2 {
      font-size: 4.5rem;
  }
}

@media (max-width: 991.98px) {
  html {
      font-size: 13px;
  }

  h1 {
      font-size: 4rem;
  }

  h2 {
      font-size: 3rem;
  }

  .display-1 {
      font-size: 4.5rem;
  }

  .display-2 {
      font-size: 4rem;
  }
}

@media (max-width: 721.98px) {
  html {
      font-size: 14px;
  }

  h1 {
      font-size: 3.5rem;
  }

  h2 {
      font-size: 2.75rem;
  }

  .display-1 {
      font-size: 4rem;
  }

  .display-2 {
      font-size: 3.5rem;
  }
}

h1 {
  font-weight: 700;
}

h3 {
  display: block;
  width: fit-content;
  border-bottom: .25rem solid var(--bs-primary);
  margin-bottom: 3rem;
}

h4 {
  display: block;
  width: fit-content;
  border-bottom: .25rem solid var(--bs-primary);
  margin-bottom: 1.5rem;
}

h5.lead {
  display: block;
  width: fit-content;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.25rem;
  border-bottom: .25rem solid var(--bs-primary);
  margin-bottom: 1.5rem;
}

h6 {
  text-transform: uppercase;
  letter-spacing: 0.1rem;
}

// Body images render at the size the editor chose, never wider than the body; one sized by width
// keeps its ratio, one sized only by a height attribute keeps that height. Same body ids as the
// BL-1155 alignment rules, plus the main body.
:is(#page-body-body, #page-body-main-body, #page-body-media-body) {
  img {
    max-width: 100%;
  }

  img:is([width], [style*="width"]) {
    height: auto;
  }

  // Media embedded at one of the bioland_width_* view modes (the drupal module's CKEditor media
  // size presets) takes that share of the body width; phones always get the full width.
  @each $percent in 25, 50, 75, 100 {
    .media--view-mode-bioland-width-#{$percent} {
      width: $percent * 1%;
    }
  }

  [class*="media--view-mode-bioland-width-"] {
    max-width: 100%;

    img {
      width: 100%;
      height: auto;
    }

    @media (max-width: 767.98px) {
      width: 100%;
    }
  }
}

h1,
.h1,
h2,
.h2 {
  animation: .5s fadeUp ease;
  line-height: 110%;
}

@keyframes fadeUp {
  0% {
      transform: translate(0, .2em);
      opacity: 0;
  }

  100% {
      transform: translate(0, 0);
      opacity: 1;
  }
}

</style>